import { useHotkeys } from "react-hotkeys-hook";
import useUndoLib from "use-undo";

export const useUndo = <T>(initialValue: T) => {
  const [value, { set, undo, redo }] = useUndoLib<T>(initialValue);
  const currentValue = value.present;
  const setCurrentValue: React.Dispatch<React.SetStateAction<T>> = (fnOrValue) => {
    set(typeof fnOrValue === "function" ? (fnOrValue as Function)(currentValue) : fnOrValue);
  };

  useHotkeys("ctrl+z", undo);
  useHotkeys("ctrl+y", redo);

  return [currentValue, setCurrentValue, undo, redo] as const;
};
